export interface ImageModel {
	key: string;
	s3url: string;
}
